"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsxImportSource @emotion/react */
var react_1 = require("react");
var react_2 = require("@emotion/react");
var Typography_style_1 = require("./Typography.style");
var theme_1 = require("@prezzee/theme");
var defaultVariantMapping = {
    display1: 'h1',
    display2: 'h1',
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'p',
    subtitle2: 'p',
    body1: 'p',
    body2: 'p',
    caption: 'caption',
    link: 'p',
    inherit: 'p',
};
var Typography = (0, react_1.forwardRef)(function (_a, ref) {
    var component = _a.component, _b = _a.gutterBottom, gutterBottom = _b === void 0 ? false : _b, _c = _a.variant, variant = _c === void 0 ? 'body1' : _c, _d = _a.variantMapping, variantMapping = _d === void 0 ? defaultVariantMapping : _d, children = _a.children, rest = __rest(_a, ["component", "gutterBottom", "variant", "variantMapping", "children"]);
    var theme = (0, theme_1.useTheme)();
    var Component = component || variantMapping[variant] || 'span';
    var style = [Typography_style_1.styles[variant](theme)];
    if (!gutterBottom)
        style.push(Typography_style_1.noGutter);
    return (0, react_2.jsx)(Component, __assign({ css: style, ref: ref }, rest), children);
});
exports.default = Typography;
//# sourceMappingURL=Typography.js.map